import React from "react";
import Layout from "../../shared/Layout";
import { logAnalyticsEvent } from "../../engagement/Amplitude";
import { useShowTempMessage } from "../../shared/hooks/useUtilityContext";
import { getGeminiCompletion } from "../../ai/GeminiUtils";
import { cleanMarkdownCodeBlock } from "../../shared/utils/StringUtils";

export default function SmartSnippets() {
  const [code, setCode] = React.useState("");
  const [snippet, setSnippet] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const showTempMessage = useShowTempMessage();
  return (
    <Layout>
      <div className="prose">
        <div className="w-full flex flex-row gap-4 min-h-screen pt-8 pb-24 text-sm">
          <div className="w-1/2 bg-neutral p-0 rounded-md text-neutral-content">
            <textarea
              title="Code"
              className="h-full resize-none bg-transparent p-4 font-mono w-full 
          caret-white leading-normal outline-none overflow-x-scroll no-scrollbar whitespace-pre"
          placeholder="Paste your code here."
              value={code}
              rows={30}
              onPaste={async (e) => {
                setCode(e.clipboardData.getData("text/plain"));
                setLoading(true);
                const snippetResponse = await getGeminiCompletion({
                  prompt: `Give me a VS Code Snippet for the following code: \n${e.clipboardData.getData(
                    "text/plain"
                  )}. 
                
                Add all necessary variables and placeholders (ex. "\${name:default}").
                
                Use these variables as necessary:
TM_SELECTED_TEXT The currently selected text or the empty string
TM_CURRENT_LINE The contents of the current line
TM_CURRENT_WORD The contents of the word under cursor or the empty string
TM_LINE_INDEX The zero-index based line number
TM_LINE_NUMBER The one-index based line number
TM_FILENAME The filename of the current document
TM_FILENAME_BASE The filename of the current document without its extensions
BLOCK_COMMENT_START
BLOCK_COMMENT_END 
LINE_COMMENT

A sample output looks like this:
{
  "For Loop": {
    "prefix": ["for", "for-const"],
    "body": ["for (const \${2:element} of \${1:array}) {", "\\t$0", "}"],
    "description": "A for loop."
  }
}`,
                  model: "gemini-1.5-pro-latest",
                });

                if (snippetResponse) {
                  setSnippet(cleanMarkdownCodeBlock(snippetResponse));
                }

                setLoading(false);
              }}
              onChange={(e) => setCode(e.target.value)}
            ></textarea>
          </div>
          <div className="w-1/2 bg-neutral p-0 rounded-md relative text-neutral-content">
            <textarea
              title="Snippet"
              className="h-full resize-none bg-transparent p-4 font-mono w-full 
          caret-white leading-normal outline-none overflow-x-scroll no-scrollbar whitespace-pre"
              value={snippet}
              rows={30}
              onChange={(e) => setSnippet(e.target.value)}
            ></textarea>
            {loading && (
              <div className="absolute top-4 right-4">
                <div className="spinner spinner-primary"></div>
              </div>
            )}
            {snippet && (
              <div className="absolute bottom-4 right-4">
                <button
                  title="Copy Snippet"
                  className="btn btn-sm btn-primary"
                  onClick={() => {
                    logAnalyticsEvent("Copied VS Code Snippet");
                    navigator.clipboard.writeText(snippet);
                    showTempMessage("Snippet copied to clipboard!");
                  }}
                >
                  Copy
                </button>
              </div>
            )}
          </div>
        </div>
        <h1 className="my-0">Smart Snippets</h1>
        <p className="pb-24">
          Paste your code on the left to generate a VS Code snippet with
          auto-generated variables.
        </p>
      </div>
    </Layout>
  );
}
